(function() {
  'use strict';

  angular
    .module('rmdrink', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize',
                        'ngMessages', 'ngResource', 'ui.router', 'ngMaterial',
                        'toastr', 'angulartics', 'angulartics.google.analytics',
                        'bootstrapLightbox']);

})();

(function() {
  'use strict';

  angular
    .module('rmdrink')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $timeout, $analytics, $stateParams, rulez, $mdDialog, $mdMedia) {
    var vm = this;

    $analytics.pageTrack('/');

    vm.shareURL = "https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Frickandmortydrinkinggame.com";

    // Change the default level based on the hostname
    vm.smokingGameSite = false;
    var hostname = window.location.hostname;
    if (hostname.indexOf("rickandmortysmokinggame") > -1) {
      vm.rickedness = $stateParams["rickedness"] || 420;
      vm.smokingGameSite = true;
    }
    else {
      vm.rickedness = $stateParams["rickedness"] || 1;
    }

    vm.fourtwenty = false;

    $scope.$watch(function () {
       return vm.rickedness;
    },function(value){
        if (value == 420) {
          // #420blazeit
          vm.fourtwenty = true;
        }
        else {
          vm.fourtwenty = false;
        }

        window.location.hash = "#/"+vm.rickedness;
    });

    // Determine whether a give rule is in the current rickedness level
    vm.ricked = function(rule) {
      if (vm.rickedness >= rule.level && vm.rickedness != 420){
        return true;
      }
      else if (rule.level == 420 && vm.rickedness == 420) {
        // #420blazeit
        return true;
      }
      return false;
    };

    // Share on facebook was clicked, track this event
    vm.fbShare = function() {
      $analytics.eventTrack('shareClicked');
    };

    // Someone clicked my website!
    vm.siteClick = function() {
      $analytics.eventTrack('websiteClicked');
    };

    // Share on facebook was clicked, track this event
    vm.githubClick = function() {
      $analytics.eventTrack('githubClicked');
    };

    vm.rules = rulez;

    // Detect the konami code and spawn the video dialog
    var konami = new Konami();
    konami.code = function() {
      vm.konamiVid();
    }
    konami.load();

    // Spawn that ish
    vm.konamiVid = function() {
      $analytics.eventTrack('konami');
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;
      $mdDialog.show({
        controller: 'KonamiController',
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'app/main/konami.tmpl.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
      });

      // $scope.$watch(function() {
      //   return $mdMedia('xs') || $mdMedia('sm');
      // }, function(wantsFullScreen) {
      //   $scope.customFullscreen = (wantsFullScreen === true);
      // });
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('rmdrink')
    .controller('KonamiController', KonamiController);

  /** @ngInject */
  function KonamiController($mdDialog, $sce) {
    var vm = this;

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    // The videos that we're gonna randomly choose from
    var videos = [
      {
        title: "X Gon' Give It To Ya",
        src: "https://www.youtube.com/embed/ExitLAP6F9U"
      },
      {
        title: "Butter",
        src: "https://www.youtube.com/embed/X7HmltUWXgs"
      },
      {
        title: "Get your shit together",
        src: "https://www.youtube.com/embed/jl17CYYSzUw"
      },
      {
        title: "Everybody needs a Plumbus in their home",
        src: "https://www.youtube.com/embed/eMJk4y9NGvE"
      }
    ];

    // Choose a random video
    var rand = Math.floor(Math.random() * videos.length);
    var video = videos[rand];

    // Display it in the iframe
    vm.src = $sce.trustAsResourceUrl(video.src);
    vm.title = video.title;
  }
})();

/*
 * Konami-JS ~
 * :: Now with support for touch events and multiple instances for
 * :: those situations that call for multiple easter eggs!
 * Code: http://konami-js.googlecode.com/
 * Examples: http://www.snaptortoise.com/konami-js
 * Copyright (c) 2009 George Mandis (georgemandis.com, snaptortoise.com)
 * Version: 1.4.5 (3/2/2016)
 * Licensed under the MIT License (http://opensource.org/licenses/MIT)
 * Tested in: Safari 4+, Google Chrome 4+, Firefox 3+, IE7+, Mobile Safari 2.2.1 and Dolphin Browser
 */

var Konami = function (callback) {
    var konami = {
        addEvent: function (obj, type, fn, ref_obj) {
            if (obj.addEventListener)
                obj.addEventListener(type, fn, false);
            else if (obj.attachEvent) {
                // IE
                obj["e" + type + fn] = fn;
                obj[type + fn] = function () {
                    obj["e" + type + fn](window.event, ref_obj);
                }
                obj.attachEvent("on" + type, obj[type + fn]);
            }
        },
        input: "",
        pattern: "38384040373937396665",
        load: function (link) {
            this.addEvent(document, "keydown", function (e, ref_obj) {
                if (ref_obj) konami = ref_obj; // IE
                konami.input += e ? e.keyCode : event.keyCode;
                if (konami.input.length > konami.pattern.length)
                    konami.input = konami.input.substr((konami.input.length - konami.pattern.length));
                if (konami.input == konami.pattern) {
                    konami.code(link);
                    konami.input = "";
                    e.preventDefault();
                    return false;
                }
            }, this);
            this.iphone.load(link);
        },
        code: function (link) {
            window.location = link
        },
        iphone: {
            start_x: 0,
            start_y: 0,
            stop_x: 0,
            stop_y: 0,
            tap: false,
            capture: false,
            orig_keys: "",
            keys: ["UP", "UP", "DOWN", "DOWN", "LEFT", "RIGHT", "LEFT", "RIGHT", "TAP", "TAP"],
            code: function (link) {
                konami.code(link);
            },
            load: function (link) {
                this.orig_keys = this.keys;
                konami.addEvent(document, "touchmove", function (e) {
                    if (e.touches.length == 1 && konami.iphone.capture == true) {
                        var touch = e.touches[0];
                        konami.iphone.stop_x = touch.pageX;
                        konami.iphone.stop_y = touch.pageY;
                        konami.iphone.tap = false;
                        konami.iphone.capture = false;
                        konami.iphone.check_direction();
                    }
                });
                konami.addEvent(document, "touchend", function (evt) {
                    if (konami.iphone.tap == true) konami.iphone.check_direction(link);
                }, false);
                konami.addEvent(document, "touchstart", function (evt) {
                    konami.iphone.start_x = evt.changedTouches[0].pageX;
                    konami.iphone.start_y = evt.changedTouches[0].pageY;
                    konami.iphone.tap = true;
                    konami.iphone.capture = true;
                });
            },
            check_direction: function (link) {
                x_magnitude = Math.abs(this.start_x - this.stop_x);
                y_magnitude = Math.abs(this.start_y - this.stop_y);
                x = ((this.start_x - this.stop_x) < 0) ? "RIGHT" : "LEFT";
                y = ((this.start_y - this.stop_y) < 0) ? "DOWN" : "UP";
                result = (x_magnitude > y_magnitude) ? x : y;
                result = (this.tap == true) ? "TAP" : result;

                if (result == this.keys[0]) this.keys = this.keys.slice(1, this.keys.length);
                if (this.keys.length == 0) {
                    this.keys = this.orig_keys;
                    this.code(link);
                }
            }
        }
    }

    typeof callback === "string" && konami.load(callback);
    if (typeof callback === "function") {
        konami.code = callback;
        konami.load();
    }

    return konami;
};

(function() {
  'use strict';

  angular
    .module('rmdrink')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('rmdrink')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/:rickedness',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('rmdrink')
    .constant('moment', moment)
    .constant('rulez',[
      {
        rule: "Any time Rick burps",
        level: 3
      },
      {
        rule: "Any time Rick drinks",
        level: 2
      },
      {
        rule: "Any time Rick or Morty stutter",
        level: 3
      },
      {
        rule: "Any time Morty says \"Uhhh...Rick\" or \"Aw geez, Rick\"",
        level: 2
      },
      {
        rule: "Any time someone goes through a portal",
        level: 1
      },
      {
        rule: "WUBBALUBBADUBDUB!!!!",
        level: 1
      },
      {
        rule: "Any time Jerry does/says anything dumb",
        level: 1
      },
      {
        rule: "Any time anyone says \"bitch\", BITCH!",
        level: 3
      },
      {
        rule: "Any time there's a reference to Morty being \"slow\"",
        level: 1
      },
      {
        rule: "Any time Rick whips out a zaneay invention",
        level: 1
      },
      {
        rule: "Any time a fight scene begins",
        level: 2
      },
      {
        rule: "Any time Beth drinks wine",
        level: 1
      },
      {
        rule: "Any time Rick and Morty gets real",
        level: 1
      },
      {
        rule: "Any time a penis is drawn into the scene",
        level: 2
      },
      {
        rule: "Any time they break the 4th wall",
        level: 1
      },
      {
        rule: "Any time a named character dies",
        level: 3
      },
      {
        rule: "Any time they talk about Beth being a horse surgeon",
        level: 1
      },
      {
        rule: "Any time Summer gets annoyed",
        level: 2
      },
      {
        rule: "Any time Morty wants to bail",
        level: 2
      },
      {
        rule: "Any time they mention a dimension",
        level: 3
      },
      {
        rule: "Any time they say the name of the epiode",
        level: 1
      },
      {
        rule: "Any time they spit on someone",
        level: 1
      },
      {
        rule: "Any time Morty or Summer gets it in",
        level: 1
      },
      {
        rule: "Any time Morty blows up",
        level: 1
      },
      {
        rule: "Mr. Poopybutthole = FINISH YOUR DRINK",
        level: 2
      },
      {
        rule: "Any time you just totally forget what's going on",
        level: 420,
        who: 1
      },
      {
        rule: "Any time you pause the show",
        level: 420,
        who: 1
      },
      {
        rule: "Any time you giggle before the joke even starts",
        level: 420,
        who: 1
      },
      {
        rule: "Any time you recognize a random alien species",
        level: 420,
        who: 1
      },
      {
        rule: "Any time you unintentionally quote the show",
        level: 420,
        who: 1
      },
      {
        rule: "Any time they smoke anything",
        level: 420,
        who: 0
      },
      {
        rule: "Any time they break the 4th wall",
        level: 420,
        who: 0
      },
    ]);

})();

(function() {
  'use strict';

  angular
    .module('rmdrink')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("rmdrink").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/konami.tmpl.html","<md-dialog aria-label=\"Rick and Morty Videosss\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"zmdi zmdi-close zmdi-hc-2x\" class=\"close-btn\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><iframe width=\"750\" height=\"450\" ng-src=\"{{vm.src}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/main.html","<div class=\"rm-bg\" ng-class=\"{\'fourtwenty\': vm.fourtwenty}\" layout-align=\"center\" layout=\"row\" layout-fill=\"\"><div class=\"container\"><div class=\"logo\"><img ng-src=\"assets/images/rm-logo.png\" ng-hide=\"vm.fourtwenty\" alt=\"logo\"> <img ng-src=\"assets/images/rm-logo-420.png\" ng-show=\"vm.fourtwenty\" alt=\"logo\"></div><div class=\"content\"><md-content><h3>I wanna get...</h3><md-radio-group ng-model=\"vm.rickedness\" ng-change=\"\"><md-radio-button value=\"420\" class=\"md-hue-3\" ng-if=\"vm.smokingGameSite\"><img ng-src=\"/assets/images/pot-leaf-icon.png\" alt=\"pot\" width=\"30\"><span class=\"blazed\">Riggity Riggity Ripped!!</span><img ng-src=\"/assets/images/pot-leaf-icon.png\" alt=\"pot\" width=\"30\"></md-radio-button><md-radio-button value=\"1\">Ricked</md-radio-button><md-radio-button value=\"2\" class=\"md-hue-2\"><strong>Schwifty</strong></md-radio-button><md-radio-button value=\"3\" class=\"md-hue-3\"><strong><i>Riggity Riggity Wrecked!!</i></strong></md-radio-button><md-radio-button value=\"420\" class=\"md-hue-3\" ng-if=\"!vm.smokingGameSite\"><img ng-src=\"/assets/images/pot-leaf-icon.png\" alt=\"pot\" width=\"30\"><span class=\"blazed\">Riggity Riggity Ripped!!</span><img ng-src=\"/assets/images/pot-leaf-icon.png\" alt=\"pot\" width=\"30\"></md-radio-button></md-radio-group><md-divider></md-divider><h3 ng-show=\"!vm.fourtwenty\">Drink, son!</h3><h3 ng-show=\"vm.fourtwenty\">Take a hit, dawg!</h3><p ng-show=\"vm.fourtwenty\">Play this game with your friends, whoever you catch breaking the rule has to take a hit. If one of the rules happens in the show, you pass the bowl around for a group toke. Happy Holidaze!</p><ol><li class=\"drink-rule\" ng-repeat=\"rule in vm.rules | filter: vm.ricked\">{{rule.rule}} <strong ng-if=\"rule.who==0\">(Group toke)</strong></li></ol></md-content></div><div class=\"footer\"><a ng-click=\"vm.githubClick()\" href=\"https://github.com/markkohdev/riggitywrecked\" target=\"_blank\">Made with</a> <i class=\"zmdi zmdi-favorite\"></i> by <a ng-click=\"vm.siteClick()\" href=\"http://markkoh.net\" target=\"_blank\">Mark Koh</a> | <a href=\"https://github.com/markkohdev/riggitywrecked/issues\" target=\"_blank\">Submit Feedback</a> | <a ng-click=\"vm.fbShare()\" href=\"{{vm.shareURL}}\" target=\"_blank\">Share on <i class=\"zmdi zmdi-facebook-box\"></i></a><div class=\"konami\"><img ng-src=\"assets/images/konami-black.png\" ng-show=\"vm.fourtwenty\" alt=\"konami\"> <img ng-src=\"assets/images/konami-white.png\" ng-hide=\"vm.fourtwenty\" alt=\"konami\"></div></div></div></div>");}]);